import TextEntryContainer from './container'
export default TextEntryContainer
